var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnefootballLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 23,
    viewBox: "0 0 173 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_42)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0542 18.298C26.0542 20.9039 23.9699 23 21.3786 23C18.7872 23 16.7029 20.9039 16.7029 18.298C16.7029 15.6921 18.7872 13.596 21.3786 13.596C23.9417 13.6244 26.0542 15.7204 26.0542 18.298Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09785 -1.52588e-05C8.33735 2.77585 5.43618 5.21181 1.7745 4.64531L0 9.74383C8.67535 10.7919 12.5624 6.51476 14.7312 -1.52588e-05H9.09785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6284 12.8313V15.0406H72.3884V18.0431H62.2202V4.95688H72.3884V7.95934H65.6284V9.91378H72.0222V12.8313H65.6284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0636 9.91378L83.0918 12.8313H77.4585V18.0431H74.0503V4.95688H84.0213V7.95934H77.4585V9.91378H83.0636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.285 7.95934H121.398V18.0431H117.99V7.95934H114.103V4.95688H125.285V7.95934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.073 14.1909C138.073 16.4002 136.693 18.0431 133.539 18.0431H126.948V4.95688H133.341C136.327 4.95688 137.707 6.59974 137.707 8.55417C137.707 9.7155 137.116 10.7069 136.383 11.1318V11.5C137.2 11.8399 138.073 12.9162 138.073 14.1909ZM130.356 9.97043H132.891C133.623 9.97043 134.243 9.7155 134.243 8.86575C134.243 8.01599 133.595 7.73274 132.863 7.73274H130.356V9.97043V9.97043ZM134.581 14.0209C134.581 13.0579 133.905 12.718 133.06 12.718H130.356V15.2389H133.003C133.764 15.2389 134.581 14.9556 134.581 14.0209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.184 14.814V18.0431H153.058V4.92856H156.438V14.814H162.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173 14.814V18.0431H163.846V4.92856H167.254V14.814H173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.6826 4.73029C87.9646 4.73029 84.9226 7.76107 84.9226 11.5C84.9226 15.2389 87.9364 18.2697 91.6826 18.2697C95.4006 18.2697 98.4426 15.2389 98.4426 11.5C98.4145 7.76107 95.4006 4.73029 91.6826 4.73029ZM91.6826 15.1539C89.6546 15.1539 88.1336 13.5111 88.1336 11.5C88.1336 9.48891 89.6828 7.84605 91.6826 7.84605C93.6825 7.84605 95.2316 9.48891 95.2316 11.5C95.2316 13.5394 93.6825 15.1539 91.6826 15.1539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.611 4.73029C102.893 4.73029 99.8511 7.76107 99.8511 11.5C99.8511 15.2389 102.865 18.2697 106.611 18.2697C110.329 18.2697 113.371 15.2389 113.371 11.5C113.343 7.76107 110.329 4.73029 106.611 4.73029ZM106.611 15.1539C104.583 15.1539 103.062 13.5111 103.062 11.5C103.062 9.48891 104.611 7.84605 106.611 7.84605C108.639 7.84605 110.16 9.48891 110.16 11.5C110.16 13.5394 108.611 15.1539 106.611 15.1539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4334 4.73029C35.7153 4.73029 32.6733 7.76107 32.6733 11.5C32.6733 15.2389 35.6872 18.2697 39.4334 18.2697C43.1514 18.2697 46.1934 15.2389 46.1934 11.5C46.1652 7.76107 43.1514 4.73029 39.4334 4.73029ZM39.4334 15.1539C37.4053 15.1539 35.8843 13.5111 35.8843 11.5C35.8843 9.48891 37.4335 7.84605 39.4334 7.84605C41.4614 7.84605 42.9824 9.48891 42.9824 11.5C42.9824 13.5394 41.4332 15.1539 39.4334 15.1539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.326 18.0431H151.65L148.326 4.92856H145.34H144.89H142.101L138.665 18.0431H141.988L142.777 14.9557H147.509L148.326 18.0431ZM143.509 12.1515L145.115 5.80664L146.777 12.1515H143.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2911 4.98521V17.4199L54.1082 4.98521H50.8972H50.6719H47.6299V18.0431H50.8972V5.83497L54.1082 18.0431H57.2911H57.4319H60.5584V4.98521H57.2911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6043 -1.52588e-05L7.60498 22.7451H13.3792L21.3785 -1.52588e-05H15.6043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnefootballLight);
export default __webpack_public_path__ + "static/media/onefootball-light.a4459e0209cda865008603c6974e4a07.svg";
export { ForwardRef as ReactComponent };